import { render } from "./ProjectImportPreview.vue?vue&type=template&id=3e5d9566"
import script from "./ProjectImportPreview.vue?vue&type=script&lang=js"
export * from "./ProjectImportPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__